export const CMSLocationRelatedFromJSON = (json: ICMSLocationRelated): ICMSLocationRelatedModel => {
	const fromJSON = (json: ICMSLocationRelated) => {
		const { cms_location, created_at, updated_at, location, ...rest } = json

		return {
			...rest,
			cmsLocation: cms_location,
			location: LocationFromJSON(location),
			createdAt: created_at,
			updatedAt: updated_at,
		}
	}

	return { ...fromJSON(json) }
}

export const CMSLocationRelatedToJSON = (obj: Partial<ICMSLocationRelatedModel>): Partial<ICMSLocationRelated> => {
	const { cmsLocation, createdAt, updatedAt, location, ...rest } = obj

	return {
		...rest,
		cms_location: cmsLocation,
		location: location ? locationToJSON(location) : null,
		created_at: createdAt,
		updated_at: updatedAt,
	}
}

export const CMSLocationRelatedExtendedFromJSON = (json: ICMSLocationRelatedExtended): ICMSLocationRelatedExtendedModel => {
	const fromJSON = (json: ICMSLocationRelatedExtended) => {
		const { cms_location, created_at, updated_at, location, ...rest } = json

		return {
			...rest,
			cmsLocation: CMSLocationFromJSON(cms_location),
			location: LocationFromJSON(location),
			createdAt: created_at,
			updatedAt: updated_at,
		}
	}

	return { ...fromJSON(json) }
}

export const CMSLocationRelatedExtendedToJSON = (obj: Partial<ICMSLocationRelatedExtendedModel>): Partial<ICMSLocationRelatedExtended> => {
	const { cmsLocation, createdAt, updatedAt, location, ...rest } = obj

	return {
		...rest,
		cms_location: cmsLocation ? CMSLocationToJSON(cmsLocation) : null,
		location: location ? locationToJSON(location) : null,
		created_at: createdAt,
		updated_at: updatedAt,
	}
}
